import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageEmployeeCommissionLayer from "../../../components/Admin/ManageEmployeeCommissionLayer";

const ManageEmployeeCommission = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageEmployeeCommissionLayer />
      </MasterLayout>
    </>
  );
};

export default ManageEmployeeCommission;